// Pure helpers for the inline images pasted into the rich composer.
//
// `RichBodyEditor` stamps every pasted image as
// `<img src="blob:…" data-pa-attach-id="<localId>">`; the File itself sits in a
// module-level registry there. At send time the pipeline (lib/outbound-send.ts)
// finds those markers, uploads each file and swaps the blob: src for the public
// Storage URL. These two functions are the string half of that, split out of
// the component so the send pipeline — and its tests — need no React.

/** Walk an HTML string and return each inline-image localId. Used by the
 *  send pipeline to know which images need uploading. */
export function findInlineImageIds(html: string): string[] {
  const ids: string[] = [];
  const re = /<img\b[^>]*\bdata-pa-attach-id\s*=\s*["']([^"']+)["'][^>]*>/gi;
  let m: RegExpExecArray | null;
  while ((m = re.exec(html)) !== null) ids.push(m[1]!);
  return ids;
}

/** Rewrite an HTML string, replacing the blob: src of inline images with
 *  permanent URLs from the supplied id → URL map. Removes the
 *  data-pa-attach-id attr after rewriting (it's our local marker, not
 *  meaningful to the recipient). */
export function rewriteInlineImageSrcs(html: string, idToUrl: Map<string, string>): string {
  return html.replace(
    /<img\b([^>]*?)\bdata-pa-attach-id\s*=\s*["']([^"']+)["']([^>]*?)>/gi,
    (full, before: string, id: string, after: string) => {
      const url = idToUrl.get(id);
      if (!url) return full; // upload failed; leave broken (caller toasts)
      // Remove the existing src and inject our public URL.
      const cleanedBefore = before.replace(/\bsrc\s*=\s*["'][^"']*["']/i, '').trim();
      const cleanedAfter = after.replace(/\bsrc\s*=\s*["'][^"']*["']/i, '').trim();
      return `<img ${cleanedBefore} src="${url}" ${cleanedAfter}>`.replace(/\s+/g, ' ').replace(/\s*>/, '>');
    },
  );
}
